import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=67c2dd6a&scoped=true&"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=67c2dd6a&lang=less&scoped=true&"
import style1 from "./WarehouseDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2dd6a",
  null
  
)

export default component.exports